module.exports = "/_next/static/images/ead024919e6f9d244b3a92c612972702-fastcompany.png.webp";